import { Element } from '@vindr/services/apis/element.api';
import { decodeHTMLEntities } from '@vindr/utils/converter';
import { removeEmptySpace } from '@vindr/utils/formatText';
import { Omit } from '@vindr/utils/helpers/common.helper';
import { BaseElementProps } from '../base';
import BaseElement from '../base/BaseElement';
import { ElementFactory } from '../base/ElementFactory';
import { StructuredReportElement } from '../types';
import { SECTION_TYPE } from '@vindr/services/apis/templateStructuredReport';

export interface StructuredElementProps extends BaseElementProps {
  elements: Element[];
  value: string;
  name: SECTION_TYPE;
}

class StructuredElement extends BaseElement {
  public elements: StructuredReportElement[];
  public label: string;
  public value: string;
  public level: number;
  public is_show_label: boolean;
  private props: StructuredElementProps;
  public name: SECTION_TYPE;

  constructor(props: StructuredElementProps) {
    super(props);
    this.props = props;
    this.level = (props.parent?.level ?? -1) + 1;
    this.elements = [];
    this.value = props.value ?? props.content ?? '';
    this.label = props.label || '';
    this.is_show_label = props?.is_show_label;
    this.name = props?.name;
    this.elements = Array.isArray(props.elements)
      ? props.elements.map((el: any) =>
          ElementFactory.createElement({
            ...el,
            parent: this,
            level: this.level + 1,
          })
        )
      : [];
  }

  public setElements(elements: Element[]) {
    if (!Array.isArray(elements)) {
      console.error('Elements should be an array', elements);
      return this;
    }

    this.elements = elements.map((element) =>
      ElementFactory.createElement({
        ...element,
        parent: this,
        level: this.level + 1,
      })
    );

    return this;
  }

  /*   public loadElements() {
    if (this.elements.length === 0 && Array.isArray(this.props.elements)) {
      const e = this.props.elements.map((el: any) =>
        ElementFactory.createElement({
          ...el,
          parent: this,
        })
      );
      this.elements = e;
    }
    return this;
  } */

  public setValue(value: string) {
    this.value = value;
    return this;
  }

  public setHighlight(val: boolean): void {
    this.highlight = val;
    // If need hightlight, just need highlight this, else should dehighlight every childrens
    if (this.elements && val === false) {
      for (const child of this.elements) {
        if (typeof child?.setHighlight === 'function') {
          child.setHighlight(val);
        } else {
          console.error('Not have setHighlight function on child', child);
        }
      }
    }
  }

  public findElementById(id: string): BaseElement | undefined {
    return this.elements.find((e) => e.id === id);
  }

  public render(): string {
    if (this.is_hidden) return '';
    const header = this.is_show_label ? `<p class='${this.name} ${this.id}'>${this.label}</p>` : '';
    const body = removeEmptySpace(decodeHTMLEntities(this.value));
    if (!body) return;
    let result = header
      ? `<article data-name="${this.name}" data-type="${this.type}">${header}<section data-name="${this.name}" data-type="${this.type}">${body}</section></article>`
      : `<section data-name="${this.name}" data-type="${this.type}">${body}</section>`;
    for (const child of this.elements) {
      if (!child) {
        console.error('Child is not Element', child);
        return '';
      }
      const placeholder = `{{${removeEmptySpace(child.name)}}}`;
      result = result.replace(placeholder, child.render());
    }
    return this.withHighlight(result);
  }

  public toJSON() {
    const json = Omit(this, ['parent', 'props', 'highlight']);
    json.elements = this.elements.map((child) =>
      typeof child?.toJSON === 'function' ? child.toJSON() : child
    );
    return json;
  }
}

export default StructuredElement;
